const harmonyIconPaths = {
  "activity": '<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>',
  "arrow-right": '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
  "arrow-up": '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  "badge-check": '<circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.2 2.2 4.8-4.8"/>',
  "briefcase-business": '<rect width="18" height="14" x="3" y="7" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18"/>',
  "calendar-check": '<path d="M8 2v4M16 2v4M3 10h18"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="m9 16 2 2 4-4"/>',
  "check": '<path d="m5 12 4 4L19 6"/>',
  "chevron-left": '<path d="m15 18-6-6 6-6"/>',
  "chevron-right": '<path d="m9 18 6-6-6-6"/>',
  "chevron-up": '<path d="m18 15-6-6-6 6"/>',
  "circle-check": '<circle cx="12" cy="12" r="10"/><path d="m8 12 2.5 2.5L16 9"/>',
  "clock-3": '<circle cx="12" cy="12" r="9"/><path d="M12 7v5h5"/>',
  "credit-card": '<rect width="20" height="14" x="2" y="5" rx="2"/><path d="M2 10h20"/>',
  "droplet": '<path d="M12 22a7 7 0 0 0 7-7c0-5-7-13-7-13S5 10 5 15a7 7 0 0 0 7 7Z"/>',
  "dumbbell": '<path d="m6.5 6.5 11 11M21 21l-1-1M3 3l1 1M18 22l4-4M2 6l4-4M3 10l7-7M14 21l7-7"/>',
  "heart-pulse": '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l4-4"/><path d="M3 12h5l2-4 3 8 2-4h6"/>',
  "leaf": '<path d="M11 20A7 7 0 0 1 4 13C4 7 9 3 20 3c0 11-4 16-10 16"/><path d="M3 21c3-6 7-10 13-13"/>',
  "lock-keyhole": '<rect width="18" height="12" x="3" y="10" rx="2"/><path d="M7 10V7a5 5 0 0 1 10 0v3M12 14v4"/>',
  "package-check": '<path d="m16 16 2 2 4-4M21 10 12 5 3 10l9 5 9-5Z"/><path d="m3 10 1 9 8 4 5-2.5M12 15v8M7.5 7.5l9 5"/>',
  "pill": '<path d="m10.5 20.5-7-7a5 5 0 0 1 7-7l7 7a5 5 0 0 1-7 7Z"/><path d="m8 9 7 7"/>',
  "plus": '<path d="M12 5v14M5 12h14"/>',
  "refresh-cw": '<path d="M20 7h-5V2M4 17h5v5"/><path d="M5.1 9A8 8 0 0 1 18.4 5L20 7M4 17l1.6 2A8 8 0 0 0 19 15"/>',
  "shield-check": '<path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3v8Z"/><path d="m9 12 2 2 4-4"/>',
  "shopping-bag": '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/>',
  "shopping-cart": '<circle cx="9" cy="20" r="1"/><circle cx="19" cy="20" r="1"/><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.6L22 8H6"/>',
  "sprout": '<path d="M7 20h10M10 20c0-5 1-8 5-11"/><path d="M9.5 9.5C5 10 3 8 3 4c4 0 7 2 6.5 5.5ZM14 8c0-4 3-6 7-6 0 4-2 7-7 6Z"/>',
  "utensils": '<path d="M3 2v7a3 3 0 0 0 6 0V2M6 2v20M16 2v8h5M19 2v20"/>'
};

const createHarmonyIcons = () => {
  document.querySelectorAll("i[data-lucide]").forEach((icon) => {
    const name = icon.dataset.lucide;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "24");
    svg.setAttribute("height", "24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden", "true");
    svg.classList.add("lucide", `lucide-${name}`);
    svg.innerHTML = harmonyIconPaths[name] || harmonyIconPaths.check;
    icon.replaceWith(svg);
  });

  document.querySelectorAll("[data-purchase-urgency]").forEach((urgency) => {
    const display = urgency.querySelector("[data-countdown-display]");
    const duration = Math.max(60, Number(urgency.dataset.countdownSeconds || 10800));
    if (!display) return;

    let remaining = duration;
    const hourValue = urgency.querySelector("[data-countdown-hour-value]");
    const minuteValue = urgency.querySelector("[data-countdown-minute-value]");
    const secondValue = urgency.querySelector("[data-countdown-second-value]");
    const usesLocalMidnight = urgency.dataset.countdownMode === "local-midnight";
    const storageKey = "harmony-sale-countdown-end-v1";
    let countdownEnd = Number(window.localStorage.getItem(storageKey));

    if (!usesLocalMidnight && (!Number.isFinite(countdownEnd) || countdownEnd <= Date.now())) {
      countdownEnd = Date.now() + duration * 1000;
      window.localStorage.setItem(storageKey, String(countdownEnd));
    }

    const renderCountdown = () => {
      if (usesLocalMidnight) {
        const now = new Date(Math.floor(Date.now() / 1000) * 1000);
        const nextMidnight = new Date(now);
        nextMidnight.setDate(nextMidnight.getDate() + 1);
        nextMidnight.setHours(0, 0, 0, 0);
        remaining = Math.max(0, Math.floor((nextMidnight.getTime() - now.getTime()) / 1000));
      } else {
        remaining = Math.max(0, Math.ceil((countdownEnd - Date.now()) / 1000));
      }

      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const paddedHours = String(hours).padStart(2, "0");
      const paddedMinutes = String(minutes).padStart(2, "0");
      const paddedSeconds = String(seconds).padStart(2, "0");

      if (hourValue && minuteValue && secondValue) {
        hourValue.textContent = paddedHours;
        minuteValue.textContent = paddedMinutes;
        secondValue.textContent = paddedSeconds;
      } else {
        display.textContent = `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
      }

      
    };

    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  });
};

const showGalleryImage = (gallery, index) => {
  const heroImage = gallery.querySelector("[data-main-product-image]");
  const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
  if (!heroImage || !thumbs.length) return;

  const normalizedIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
  const thumb = thumbs[normalizedIndex];

  thumbs.forEach((item) => {
    item.classList.remove("is-active");
    item.setAttribute("aria-pressed", "false");
  });
  thumb.classList.add("is-active");
  thumb.setAttribute("aria-pressed", "true");
  heroImage.src = thumb.dataset.galleryImage;
  heroImage.alt = thumb.getAttribute("aria-label")?.replace(/^Show /, "") || "Product image";

  const track = gallery.querySelector("[data-gallery-track]");
  if (track) {
    const target = track.scrollLeft + thumb.getBoundingClientRect().left - track.getBoundingClientRect().left - (track.clientWidth - thumb.clientWidth) / 2;
    track.scrollTo({
      left: target,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
    });
  }
};

document.querySelectorAll("[data-harmony-gallery]").forEach((gallery) => {
  const mainImage = gallery.querySelector(".main-product-image");
  if (!mainImage) return;
  let touchStart;
  mainImage.addEventListener("touchstart", (event) => {
    const touch = event.changedTouches[0];
    touchStart = { x: touch.clientX, y: touch.clientY };
  }, { passive: true });
  mainImage.addEventListener("touchend", (event) => {
    if (!touchStart) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - touchStart.x;
    const dy = touch.clientY - touchStart.y;
    touchStart = undefined;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
    const currentIndex = thumbs.findIndex((thumb) => thumb.classList.contains("is-active"));
    showGalleryImage(gallery, currentIndex + (dx < 0 ? 1 : -1));
  }, { passive: true });
});

document.addEventListener("click", (event) => {
  const control = event.target.closest("[data-gallery-image], [data-gallery-step], [data-gallery-scroll]");
  const gallery = control?.closest("[data-harmony-gallery]");
  if (!control || !gallery) return;

  if (control.matches("[data-gallery-image]")) {
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
    showGalleryImage(gallery, thumbs.indexOf(control));
    return;
  }

  if (control.matches("[data-gallery-step]")) {
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
    const currentIndex = thumbs.findIndex((thumb) => thumb.classList.contains("is-active"));
    showGalleryImage(gallery, currentIndex + Number(control.dataset.galleryStep));
    return;
  }

  const track = gallery.querySelector("[data-gallery-track]");
  track?.scrollBy({
    left: Number(control.dataset.galleryScroll) * track.clientWidth * 0.72,
    behavior: "smooth",
  });
}, { capture: true });

const initializeMobileSaleCountdown = () => {
  const bar = document.querySelector(".mobile-sale-countdown");
  if (!bar) return;

  const mobileQuery = window.matchMedia("(max-width: 720px)");
  const updateVisibility = () => {
    const isActive = mobileQuery.matches && window.scrollY > 400;
    bar.classList.toggle("is-active", isActive);
    bar.setAttribute("aria-hidden", String(!isActive));
  };

  updateVisibility();
  window.addEventListener("scroll", updateVisibility, { passive: true });
  window.addEventListener("resize", updateVisibility);
  mobileQuery.addEventListener?.("change", updateVisibility);
};

const initializeHarmonyTheme = () => {
  createHarmonyIcons();
  initializeMobileSaleCountdown();

  document.querySelectorAll("[data-nav-dropdown]").forEach((dropdown) => {
    const toggle = dropdown.querySelector("[data-nav-dropdown-toggle]");

    toggle?.addEventListener("click", (event) => {
      event.stopPropagation();
      const isOpen = dropdown.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  });

  document.addEventListener("click", (event) => {
    document.querySelectorAll("[data-nav-dropdown].is-open").forEach((dropdown) => {
      if (dropdown.contains(event.target)) return;
      dropdown.classList.remove("is-open");
      dropdown.querySelector("[data-nav-dropdown-toggle]")?.setAttribute("aria-expanded", "false");
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-nav-dropdown].is-open").forEach((dropdown) => {
      dropdown.classList.remove("is-open");
      dropdown.querySelector("[data-nav-dropdown-toggle]")?.setAttribute("aria-expanded", "false");
    });
  });

  document.querySelectorAll(".purchase-box").forEach((form) => {
    const options = form.querySelectorAll(".supply-option");
    const variantRadios = form.querySelectorAll("[data-variant-radio]");
    const variantMeta = form.querySelector("[data-product-variant-meta]");
    const productVariantIds = new Set(
      [variantMeta?.dataset.productVariantIds || "", Array.from(variantRadios).map((radio) => radio.value).join(",")]
        .join(",")
        .split(",")
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id))
    );

    const selectOption = (option) => {
      const radio = option.querySelector("[data-variant-radio]");
      if (!radio || radio.disabled) return;

      radio.checked = true;
      options.forEach((item) => item.classList.remove("is-selected"));
      option.classList.add("is-selected");
    };

    const fallbackRadio = () => {
      return form.querySelector("[data-default-variant-radio]") ||
        Array.from(variantRadios).find((radio) => !radio.disabled) ||
        null;
    };

    const selectedRadio = () => {
      return form.querySelector("[data-variant-radio]:checked") || fallbackRadio();
    };

    options.forEach((option) => {
      const radio = option.querySelector("[data-variant-radio]");

      option.addEventListener("click", () => selectOption(option));
      radio?.addEventListener("change", () => selectOption(option));
    });

    const defaultRadio = fallbackRadio();
    if (defaultRadio) selectOption(defaultRadio.closest(".supply-option"));

    form.addEventListener("submit", async (event) => {
      const radio = selectedRadio();
      if (!radio || radio.disabled) return;

      selectOption(radio.closest(".supply-option"));

      const selectedVariantId = Number(radio.value);
      if (!Number.isFinite(selectedVariantId) || productVariantIds.size === 0 || form.dataset.nativeSubmit === "true") return;

      event.preventDefault();

      const addButton = form.querySelector('[type="submit"]');
      const root = window.Shopify?.routes?.root || "/";
      const cartUrl = `${root}cart`;

      if (addButton) addButton.disabled = true;

      try {
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { "Accept": "application/json" },
        });

        if (!cartResponse.ok) throw new Error("Cart lookup failed");

        const cart = await cartResponse.json();
        const updates = {};

        cart.items.forEach((item) => {
          if (productVariantIds.has(Number(item.variant_id))) updates[item.key] = 0;
        });

        if (Object.keys(updates).length > 0) {
          const updateResponse = await fetch(`${root}cart/update.js`, {
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          });

          if (!updateResponse.ok) throw new Error("Cart cleanup failed");
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: selectedVariantId,
            quantity: 1,
          }),
        });

        if (!addResponse.ok) throw new Error("Add to cart failed");

        window.location.href = cartUrl;
      } catch (error) {
        form.dataset.nativeSubmit = "true";
        if (addButton) addButton.disabled = false;
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    });
  });
  document.querySelectorAll("[data-cart-form]").forEach((form) => {
    const status = form.querySelector("[data-cart-status]");
    const subtotal = form.querySelector("[data-cart-subtotal]");
    const quantityInputs = form.querySelectorAll("[data-cart-quantity]");
    let updateTimer;

    form.classList.add("is-ajax-ready");

    const root = window.Shopify?.routes?.root || "/";
    const cartChangeUrl = `${root}cart/change.js`;
    const currency = window.Shopify?.currency?.active || "USD";
    const locale = document.documentElement.lang || "en-US";

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const setStatus = (message) => {
      if (!status) return;
      status.textContent = message;
    };

    const updateHeaderCount = (itemCount) => {
      document.querySelectorAll("[data-cart-count]").forEach((count) => {
        count.textContent = itemCount > 0 ? ` (${itemCount})` : "";
      });
    };

    const updateCartPrices = (cart) => {
      cart.items.forEach((item, index) => {
        const line = String(index + 1);
        const price = form.querySelector(`[data-cart-line-price="${line}"]`);
        const compare = form.querySelector(`[data-cart-line-compare="${line}"]`);
        const quantity = form.querySelector(`[data-cart-quantity][data-cart-line="${line}"]`);

        if (price) price.textContent = formatMoney(item.final_line_price);
        if (quantity) quantity.value = item.quantity;
        if (!compare) return;

        if (item.original_line_price > item.final_line_price) {
          compare.textContent = formatMoney(item.original_line_price);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      });

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      updateHeaderCount(cart.item_count);
    };

    const syncQuantity = async (input) => {
      const quantity = Math.max(0, Number(input.value || 0));
      const line = Number(input.dataset.cartLine);
      if (!line || Number.isNaN(quantity)) return;

      form.classList.add("is-updating");
      setStatus("Updating cart total...");

      try {
        const response = await fetch(cartChangeUrl, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ line, quantity }),
        });

        if (!response.ok) throw new Error("Cart update failed");

        const cart = await response.json();
        if (quantity === 0 || cart.item_count === 0) {
          window.location.reload();
          return;
        }

        updateCartPrices(cart);
        setStatus("Cart total updated.");
      } catch (error) {
        setStatus("We could not update the total automatically. Use Update Cart to refresh it.");
      } finally {
        form.classList.remove("is-updating");
      }
    };


    quantityInputs.forEach((input) => {
      input.addEventListener("input", () => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(() => syncQuantity(input), 500);
      });

      input.addEventListener("change", () => {
        window.clearTimeout(updateTimer);
        syncQuantity(input);
      });
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeHarmonyTheme, { once: true });
} else {
  initializeHarmonyTheme();
}
